import { createSlice, PayloadAction } from "@reduxjs/toolkit";
export interface FlagState {
  loading: boolean;
  CalendarEventFlag: boolean;
  Package: boolean;
  UserEvent: boolean;
  UserTransaction: boolean;
  Quotation: boolean;
  WalletManagement: boolean;
  plan_discount: string;
  CustomerPaymentFlag: boolean;
  MediaPayment: boolean;
  isDevModeJson?: {
    isOn: boolean;
    allowed: string[];

  };
  WhiteLabelWebsite: boolean;
  Orders: boolean;
  WhatsApp: boolean;
  Leads: boolean;
}

const initialState: FlagState = {
  loading: false,
  CalendarEventFlag: false,
  Package: false,
  UserEvent: false,
  UserTransaction: false,
  Quotation: false,
  WalletManagement: false,
  CustomerPaymentFlag: false,
  plan_discount: "",
  MediaPayment: false,
  WhiteLabelWebsite: false,
  Orders: false,
  WhatsApp: false,
  Leads: false,
};

const flagSlice = createSlice({
  name: "flags",
  initialState,
  reducers: {
    setCalendarEventFlag(state, action: PayloadAction<{ value: boolean }>) {
      state.CalendarEventFlag = action.payload.value;
    },
    setPackageFlag(state, action: PayloadAction<{ value: boolean }>) {
      state.Package = action.payload.value;
    },
    setUserEventFlag(state, action: PayloadAction<{ value: boolean }>) {
      state.UserEvent = action.payload.value;
    },

    setUserTransactionFlag(state, action: PayloadAction<{ value: boolean }>) {
      state.UserTransaction = action.payload.value;
    },
    setQuotationFlag(state, action: PayloadAction<{ value: boolean }>) {
      state.Quotation = action.payload.value;
    },
    setWalletManagementFlag(state, action: PayloadAction<{ value: boolean }>) {
      state.WalletManagement = action.payload.value;
    },
    setPlanDiscount(state, action: PayloadAction<{ value: string }>) {
      state.plan_discount = action.payload.value;
    },
    setCustomerPaymentFlag(state, action: PayloadAction<{ value: boolean }>) {
      state.CustomerPaymentFlag = action.payload.value;
    },
    setMediaPaymentFlag(state, action: PayloadAction<{ value: boolean }>) {
      state.MediaPayment = action.payload.value;
    },
    setWhiteLabelFlag(state, action: PayloadAction<{ value: boolean }>) {
      state.WhiteLabelWebsite = action.payload.value;
    },
    setOrdersFlag(state, action: PayloadAction<{ value: boolean }>) {
      state.Orders = action.payload.value;
    },
    setWhatsAppFlag(state, action: PayloadAction<{ value: boolean }>) {
      state.WhatsApp = action.payload.value;
    },
    setLeadsFlag(state, action: PayloadAction<{ value: boolean }>) {
      state.Leads = action.payload.value;
    },
    setDevModeJson(state, action: PayloadAction<{ value: { isOn: boolean, allowed: string[] } }>) {
      state.isDevModeJson = action.payload.value;
    },
  },
  extraReducers: (builder) => { },
});

export const {
  setCalendarEventFlag,
  setPackageFlag,
  setUserEventFlag,
  setUserTransactionFlag,
  setQuotationFlag,
  setWalletManagementFlag,
  setPlanDiscount,
  setCustomerPaymentFlag,
  setMediaPaymentFlag,
  setWhiteLabelFlag,
  setWhatsAppFlag,
  setLeadsFlag,
  setDevModeJson,
  setOrdersFlag,
} = flagSlice.actions;

export default flagSlice.reducer;
